import axios, { AxiosResponse } from "axios";

export interface Tag {
  OID: number;
  description: string;
  name: string;
  seo_title: string;
  show_topic_title: boolean;
  slug: string;
  url: string;
}

export async function getTags(): Promise<Tag[]> {
  try {
    const res: AxiosResponse<Tag[]> = await axios.post(
      `${window.API_HOST}/api/tags/list`
    );
    return res.data;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw { status: err.response!.status, errors: err.response!.data.errors };
    } else {
      throw new Error("Cannot request info.");
    }
  }
}
